<template>
  <v-data-table
    :headers="headers"
    :items="locsPersonal"
    class="transparent"
    hide-default-footer
    disable-pagination
    calculate-widths
  >
    <template v-slot:[`item.fecha`]="{ item }">
      {{ humanizeDate(item.fecha) }}
    </template>
    <template v-slot:[`item.opciones`]="{ item }">
      <v-btn icon color="error" @click="showRemoveConfirmationDialog(item)">
        <v-icon>mdi-minus</v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import { API_DATE_FORMAT } from '@/const'
import DateAdapter from '@src/utils/DateAdapter'
import { DIALOG_TYPES } from '@src/plugins/dialog-types'
import { mapActions, mapMutations } from 'vuex'

export default {
  props: {
    locsPersonal: {
      type: Array,
      required: true,
      default: () => [],
    },
  },

  data() {
    return {
      headers: [
        { text: 'No. de licencia', value: 'Loc.noLicencia', align: 'right' },
        { text: 'Fecha de alta', value: 'fecha' },
        { text: 'Opciones', value: 'opciones' },
      ],
    }
  },

  methods: {
    ...mapMutations('dialog', ['SET_DIALOG', 'CLOSE_DIALOG']),
    ...mapActions('armeria', ['removePersonalLoc']),
    ...mapActions('personalLoc', ['fetchPersonalLoc']),

    humanizeDate(date) {
      if (date) {
        return new DateAdapter(date, API_DATE_FORMAT).toHumanReadable()
      }

      return '-'
    },

    showRemoveConfirmationDialog(locPersonal) {
      this.SET_DIALOG({
        ...DIALOG_TYPES.CONFIRMACION_REMOVER_PERSONAL_LOC,
        props: {
          onConfirm: async () => {
            await this.removePersonalLoc({
              idPersonal: locPersonal.fk_idPersonal,
              idPersonalLoc: locPersonal.idPersonalLoc,
            })
            await this.fetchPersonalLoc(locPersonal.fk_idPersonal)
            this.CLOSE_DIALOG()
          },
        },
      })
    },
  },
}
</script>
